import styled from 'styled-components/native';
import { border, color, ColorProps, PositionProps, BorderProps } from 'styled-system';

import { position } from 'theme/responsive';

export const CircleAction = styled.TouchableOpacity<ColorProps & BorderProps & PositionProps>`
  width: 35px;
  height: 35px;
  border-radius: 17.5px;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 12.5px;
  border-width: 1px;
  border-style: solid;
  ${position}
  ${color}
  ${border}
`;
